import React from "react";

const LoginLeft: React.FC = () => {
    return (
        <div className="text-white login-left lg:flex flex-col w-[45%] justify-end p-6 hidden">
            <span className="text-3xl font-extrabold">Welcome back!</span>
            <span className="text-lg">
                Login to book some great restaurants <br />
                even the ones near your current loccation
            </span>
        </div>
    )
}
export default LoginLeft;